module.exports = __webpack_public_path__ + "static/img/zchkj.10d6837a.png";